import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { homePath } from '../helpers/panelAccess';
import { appLinks } from '../constants/navLinks';
import PanelAccessDenied from '../components/PanelAccessDenied';

class ProtectedRedirectRoute extends React.Component {
    render() {
        const isAuthenticated = this.props.isAuthenticated;

        if (!isAuthenticated) return <Redirect to="/login" />;
        const home = homePath(this.props.user, appLinks);
        return home ? <Redirect to={home} /> : <PanelAccessDenied />;
    }
}

const mapStateToProps = state => {
    return { isAuthenticated: state.user && state.user.loggedin, user: state.user };
};
export default connect(mapStateToProps, {})(ProtectedRedirectRoute);
